import React from "react";
import Plot from 'react-plotly.js';

function AverageByVarietyPlot(props) {
    if (props.data === null) {
        return (
            <div>
                Failed to create visualization
            </div>
        )
    }
    else {

        const plotData = [{
            type: 'bar',
            x: [],
            y: [],
            marker: {
                color: []
            },
            orientation: 'h'
        }];
        const data = props.data[props.trait].toSorted((object1, object2) => {
            if (object1.average < object2.average)
                return -1;
            if (object1.average > object2.average)
                return 1;
            return 0;
        });
        data.forEach(record => {
            plotData[0].y.push(record.NAME);
            plotData[0].x.push(record.average);
            plotData[0].marker.color.push('rgb(102, 102, 153)')
        });

        return (
            <Plot
                data={plotData}
                layout={{ title: `Average ${props.trait} by Plant Variety`, xaxis: { title: `Average ${props.trait}` }, yaxis: { title: `Plant Variety` }, width: 1000, height: (400 + 20 * plotData[0].y.length) }}
            />
        )
    }
}

export default AverageByVarietyPlot;